import React from 'react';
import { StyledButton } from './styles.tsx';
import { BeatLoader } from 'react-spinners';
import { hapticsImpactLight } from '../../common/haptic.js';
import { useTheme } from 'styled-components';

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  variant?: 'primary' | 'secondary' | 'white' | 'link' | 'danger';
  fullWidth?: boolean;
  disabled?: boolean;
  loading?: boolean;
  style?: React.CSSProperties;
  as?: React.ElementType;
  [key: string]: any; // For any other props that might be passed
}

const Button: React.FC<ButtonProps> = ({
  children,
  onClick = (e: any) => {},
  type = 'button',
  variant = 'primary',
  fullWidth = false,
  disabled = false,
  loading = false,
  style = {},
  as,
  ...props
}) => {
  const theme = useTheme() as any;

  return (
    <StyledButton
      as={as}
      variant={variant}
      disabled={disabled}
      fullWidth={fullWidth}
      onClick={
        loading
          ? () => {}
          : (e) => {
              hapticsImpactLight();
              onClick(e);
            }
      }
      style={style}
      {...props}
    >
      {loading ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <BeatLoader
            color={style?.color || theme.background.primary}
            size={8}
            margin={2}
          />
        </div>
      ) : (
        children
      )}
    </StyledButton>
  );
};

export default Button;
